import { selectActiveViewContext, selectSelectedLotId } from '../redux/selectors';
import { VIEW_FLOOR_PLAN_DETAIL } from '../constants';

/**
 * Mobile Lot Card interaction handlers.
 *
 * Keeps interaction/business wiring out of the DOM plugin so the plugin can focus on
 * mount/unmount/render concerns only.
 *
 * @module nativeInteractiveSiteMap/handlers/mobileLotCardInteractionHandlers
 */
function createMobileLotCardInteractionHandlers({ getState, dispatch, dataActions }) {
  return {
    onReturnToDetails() {
      const storeState = getState();
      const activeViewContext = selectActiveViewContext(storeState);
      const selectedLotId = selectSelectedLotId(storeState);

      dispatch(dataActions.navigateTo({
        view: VIEW_FLOOR_PLAN_DETAIL,
        context: {
          planId: activeViewContext?.planId ?? null,
          selectedLotId: selectedLotId ?? null,
          housingUnitId: null,
        },
      }));
    },
  };
}

export default createMobileLotCardInteractionHandlers;
